module.exports = __webpack_public_path__ + "static/media/gerialine.8efcce4d.png";